import HomePage from "./Pages/Home"
const App = () => {
  return <>
    <HomePage />
  </>
}

export default App;